import { render, staticRenderFns } from "./VariantsConfigurator.vue?vue&type=template&id=ac96e644"
import script from "./VariantsConfigurator.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariantsConfigurator.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports